/* eslint-disable no-console */

export interface AppliedFilter {
  fieldName: string;
  fixedValues?: string[];
  ranges?: Array<{ rangeLowerBoundary: number; rangeUpperBoundary: number }>;
}

/**
 * Checks if the field name is a price-related filter
 */
export const isPriceFilter = (fieldName: string): boolean =>
  fieldName === 'price' || fieldName === 'price.centAmount';

/**
 * Parses a price range string like "[10, 50]" into a range object
 */
export const parseRangeValue = (value: string): { rangeLowerBoundary: number; rangeUpperBoundary: number } | null => {
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed) && parsed.length === 2) {
      return {
        rangeLowerBoundary: parsed[0],
        rangeUpperBoundary: parsed[1]
      };
    }
  } catch (error) {
    console.warn(`Failed to parse price range value: ${value}`, error);
  }

  return null;
};

/**
 * Maps selected terms to filter format for SmartSearch
 */
export const mapFiltersForSmartSearch = (selectedTerms: Record<string, string[]> = {}): AppliedFilter[] =>
  Object.entries(selectedTerms).map(([ fieldName, values ]) => {
    if (isPriceFilter(fieldName)) {
      return {
        fieldName,
        ranges: values.map(parseRangeValue).filter(Boolean) as Array<{ rangeLowerBoundary: number; rangeUpperBoundary: number }>
      };
    }

    return {
      fieldName,
      fixedValues: values
    };
  });
